import { render, staticRenderFns } from "./c2c1PaymentLinks.vue?vue&type=template&id=6beff9e0"
import script from "./c2c1PaymentLinks.vue?vue&type=script&lang=js"
export * from "./c2c1PaymentLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports